import React, {Component} from 'react';

import PortalAdminDraggable from './PortalAdminDraggable';
import {Droppable, Draggable} from 'react-beautiful-dnd';

import sAction from 'sAction';

class PortalAdminRole extends React.Component {
    render() {
        const data = this.props.data;

        const users = data.users;
        let cntUser = 0;

        return <div className="portalAdminRole">
            <Draggable draggableId={'tree_'+data.id} index={0} key={data.id} isDragDisabled={true}>
                {(provided) => (
                    <div ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <PortalAdminDraggable
                            name={data.name}
                            type="ROLES"
                            onDelete={this.props.deleteRole}
                            bId={this.props.bId}
                            rId={data.id}
                        />
                        <Droppable droppableId={data.dropId} type="USERS">
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className={'portalAdminUsersDropzone portalDropZone'+(snapshot.isDraggingOver ? ' isDragOver' : '')}
                                >
                                    <div className="portalAdminRoleUsers">
                                        {
                                            Object.keys(users).map((key, index) =>
                                                <Draggable draggableId={'tree_'+'_'+this.props.roleId+'_'+users[key].id} index={0} key={users[key].id} isDragDisabled={true}>
                                                    {(provided) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <PortalAdminDraggable
                                                                name={users[key].name}
                                                                type="USERS"
                                                                data={users[key]}
                                                                onDelete={this.props.deleteUser}
                                                                bId={this.props.bId}
                                                                rId={data.id}
                                                                uId={users[key].id}
                                                                index={cntUser++}
                                                            />
                                                        </div>
                                                    )}
                                                </Draggable>,
                                                /* Object.keys(users).map((key, index) =>
                    <div key={users[key].id} className="poratlAdminUser" >{users[key].name}</div>*/
                                            )

                                        }
                                    </div>
                                    {provided.placeholder}
                                </div>

                            )}
                        </Droppable>
                    </div>
                )}
            </Draggable>

        </div>;
    }
}
export default PortalAdminRole;
